import { useEffect, useMemo, useRef } from "react"
import { createMemoryHistory } from "history"
import { Route, Switch, useRouteMatch, Redirect, Router, useHistory } from "react-router"
import { FavoriteArticles } from "./FavoriteArticles"
import { OwnRepairTimes } from "./OwnRepairTimes"
import { OwnArticles } from "./OwnArticles"
import { useOwnListsStore } from "./store"

export type ListType = "favorite-articles" | "own-articles" | "own-repair-times"

type OwnListsProps = {
    listType?: ListType
    onClose?(): void
}

export function OwnLists({ listType, onClose }: OwnListsProps) {
    const { path } = useRouteMatch()
    const relativePath = useRef(path)
    const { setBasePath } = useOwnListsStore()

    useEffect(() => {
        setBasePath(relativePath.current)
    }, [])

    const browserHistory = useHistory()
    const history = useMemo(() => {
        if (listType) {
            relativePath.current = "/"
            return createMemoryHistory({ initialEntries: [relativePath.current] })
        }
        return browserHistory
    }, [listType])

    return (
        <Router history={history}>
            <Switch>
                <Redirect from={relativePath.current} exact to={`${relativePath.current}${listType ?? "favorite-articles"}`} />
                <Route path={`${relativePath.current}favorite-articles/:listId?`}>
                    <FavoriteArticles onClose={onClose} />
                </Route>
                <Route path={`${relativePath.current}own-articles/:listId?`}>
                    <OwnArticles onClose={onClose} />
                </Route>
                <Route path={`${relativePath.current}own-repair-times/:listId?`}>
                    <OwnRepairTimes onClose={onClose} />
                </Route>
            </Switch>
        </Router>
    )
}
